<div class="container">

  <app-header-dialog [iconName]="'noise_control_off'">
    Congresso Anterior
  </app-header-dialog>

  <div *ngIf="entityForm">

    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>settings_display</mat-icon>
          <div>Capa</div>
        </ng-template>

        <div class="content">

          <div style="margin-top: 10px;">
            <input type="file" #fileImage (change)="onFileSelected($event)" accept="mage/*" style="display:none;">
            <a mat-raised-button (click)='fileImage.click()' matTooltip='Selecionar arquivo'
              style='background-color: whitesmoke;'>
              <mat-icon class='icon-add'>image_search</mat-icon>
              Selecionar imagem
            </a>
            <span style="margin: 20px;" *ngIf="selectedFileName">{{selectedFileName}}</span>
          </div>

          <hr>

          <div style="display: flex; justify-content: center; width: 100%; margin: 10px;">
            <img [src]="storedImage" style="width: 100%; " *ngIf="storedImage">
          </div>

          <hr>
          <br>

          <mat-form-field style='width: 180px;' appearance="outline">
            <mat-label>Edição</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.edition"
              autocomplete="off">
          </mat-form-field>

          <div>
            <mat-form-field style='width: 180px;' appearance="outline">
              <mat-label>Ano</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.year"
                autocomplete="off">
            </mat-form-field>
          </div>

          <div>
            <mat-form-field style='width: 600px;' appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.name"
                autocomplete="off">
            </mat-form-field>
          </div>

          <mat-form-field style='width: 600px;' appearance="outline">
            <mat-label>Datas</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.date"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 600px;' appearance="outline">
            <mat-label>Local</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.location"
              autocomplete="off">
          </mat-form-field>

          <mat-form-field style='width: 600px;' appearance="outline">
            <mat-label>Link Para Certificados</mat-label>
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="entityForm.controls.linkCertificate"
              autocomplete="off">
          </mat-form-field>

        </div>

      </mat-tab>

      <mat-tab *ngIf="isEdit">
        <ng-template mat-tab-label>
          <mat-icon class='tab-icon'>format_list_bulleted</mat-icon>
          <div>Programa</div>
        </ng-template>

        <div class="content">
          <!-- TABLE -->
          <mat-table [dataSource]="dataSource" matSort matSortActive="position" matSortDirection='asc'
            matSortDisableClear=true>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Nome </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
            </ng-container>

            <!-- File Column -->
            <ng-container matColumnDef="file">
              <mat-header-cell *matHeaderCellDef mat-sort-header> File </mat-header-cell>
              <mat-cell *matCellDef="let element"> {{ element.file }} </mat-cell>
            </ng-container>

            <!-- preview Column -->
            <ng-container matColumnDef="preview">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button target="_blank" [href]="element.src" style='background-color: whitesmoke;'>
                  <mat-icon class='icon-add'>
                    preview
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- edit Column -->
            <ng-container matColumnDef="edit">
              <mat-header-cell *matHeaderCellDef> </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='openPDFDialog(element)' matTooltip='Editar'
                  style="background-color: whitesmoke;">
                  <mat-icon class='icon-info'>
                    info_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>

            <!-- delete Column -->
            <ng-container matColumnDef="delete">
              <mat-header-cell *matHeaderCellDef>
                <a mat-button (click)="openPDFDialog(null)" style='width:60px;'>
                  <mat-icon class="icon-add">add_circle_outline</mat-icon>
                </a>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a mat-button (click)='deletePDF(element)' matTooltip='Apagar' style='background-color: whitesmoke;'>
                  <mat-icon class='icon-delete' style="font-size:1.5em;">delete_outline
                  </mat-icon>
                </a>
              </mat-cell>
            </ng-container>


            <!-- Header -->
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

            <!-- Row -->
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

          </mat-table>
          <!-- END TABLE -->

        </div>

      </mat-tab>

    </mat-tab-group>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>

      <button *ngIf="!isEdit" matTooltip='Inserir' mat-raised-button
        (click)="matDialogRef.close(['insert', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

      <button *ngIf="isEdit" matTooltip='Alterar' mat-raised-button
        (click)="matDialogRef.close(['update', entityForm, selectedFile])" [disabled]="entityForm.invalid">
        <mat-icon class='icon-done'>check_circle_outline</mat-icon>
      </button>

    </div>

  </div>

</div>